"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinProvider = exports.FinContext = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var rxjs_1 = require("rxjs");
exports.FinContext = (0, react_1.createContext)({
    next: function () { },
    currentPath: '',
    contentMap: {},
    register: function () { },
    reset: function () { },
    initialized: false,
    initialize: function () { },
});
function FinProvider(props) {
    var _this = this;
    // prop destruction
    var children = props.children;
    // lib hooks
    // state, ref, querystring hooks
    var _a = (0, react_1.useState)(true), isLoading = _a[0], setIsLoading = _a[1];
    var finSubject = (0, react_1.useRef)(new rxjs_1.Subject());
    var handlers = (0, react_1.useRef)([]);
    var _b = (0, react_1.useState)(false), initialized = _b[0], setInitialized = _b[1];
    // Event, context state
    var contentMap = (0, react_1.useRef)({});
    var _c = (0, react_1.useState)(''), currentPath = _c[0], setCurrentPath = _c[1];
    var _d = (0, react_1.useState)(), nextPath = _d[0], setNextPath = _d[1];
    var _e = (0, react_1.useState)(), indicatorX = _e[0], setIndicatorX = _e[1];
    // form hooks
    // query hooks
    // calculated values
    var register = (0, react_1.useCallback)(function (eventHandler) {
        var _a;
        return eventHandler instanceof Array ? (_a = handlers.current).push.apply(_a, eventHandler) : handlers.current.push(eventHandler);
    }, []);
    var reset = function () {
        setCurrentPath('');
        setIndicatorX(undefined);
        setNextPath(undefined);
        contentMap.current = {};
    };
    // effects
    (0, react_1.useEffect)(function () {
        finSubject.current.subscribe(function (event) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (event.type === 'register') {
                    contentMap.current[event.currentPath] = event.children;
                }
                handlers.current.forEach(function (eventHandler) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(eventHandler.type === event.type)) return [3 /*break*/, 2];
                                event.currentPath && setCurrentPath(event.currentPath);
                                setNextPath(function (nextPath) { var _a; return (_a = event.nextPath) !== null && _a !== void 0 ? _a : nextPath; });
                                setIndicatorX(function (indicatorX) { var _a; return (_a = event.indicatorX) !== null && _a !== void 0 ? _a : indicatorX; });
                                return [4 /*yield*/, eventHandler.handler(event)];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        }); });
        setIsLoading(false);
    }, [register]);
    // handlers
    var initialize = function () {
        setInitialized(true);
    };
    if (isLoading)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    return ((0, jsx_runtime_1.jsx)(exports.FinContext.Provider, { value: {
            next: function (event) { return finSubject.current.next(event); },
            currentPath: currentPath,
            nextPath: nextPath,
            indicatorX: indicatorX,
            contentMap: contentMap.current,
            register: register,
            reset: reset,
            initialized: initialized,
            initialize: initialize,
        }, children: children }));
}
exports.FinProvider = FinProvider;
//# sourceMappingURL=FinProvider.js.map